<template>
  <v-text-field
    :outlined="outlined"
    v-bind="$attrs"
    @input="updateFieldValue(name, $event)"
    :value="currentValue"
    :messages="[error]"
    :error="!!error"
  ></v-text-field>
</template>
<script>
import baseInput from "./baseInput";
export default {
  props: {
    outlined: {
      default: true,
      type: Boolean,
    },
  },
  mixins: [baseInput],
};
</script>
